module.exports = __webpack_public_path__ + "img/wellcomeLogo78.c4f47c0.svg";